import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography, Box } from '@mui/material';
import axios from '../../../network/index';
import { ACTIONS, IMAGE, ITEM_ID, QUANTITY, REASON, RETURN_DETAILS, RETURN_ID } from '../../../constants/string';

const ReturnDetailsCard = ({ returnDetails, orderId, refreshOrder, outletId, orderData }) => {
  const serviceBizomMapping = {};

  returnDetails.forEach((returnDetail) => {
    serviceBizomMapping[returnDetail.returnId] = [];
    returnDetail.items.forEach((item) => {
      serviceBizomMapping[returnDetail.returnId].push(item.bizomReturnId);
    });
  });

  function calculateReturnAmount(saleReturnData, orderData, returnId) {
    let returnAmount = 0;

    const returnDetail = saleReturnData.find(detail => detail.returnId === returnId);

    if (returnDetail) {
        returnDetail.items.forEach(returnItem => {
            const skuId = returnItem.id;
            const quantity = returnItem.quantity;

            if (skuId !== undefined && quantity !== undefined) {
                const orderDetail = orderData.find(item => {
                    return item.Orderdetail.skunit_id === skuId.toString();
                });

                if (orderDetail) {
                    const unitprice = parseFloat(orderDetail.Orderdetail.unitprice);
                    returnAmount += quantity * unitprice;
                } 
            } 
        });
    } 
    return returnAmount;
}


  const getBizomOrder = () => {
    return axios.get(`/orders/getOrdersForOutlet/${outletId}?orderId=${orderId}`)
      .then(response => {
        try {
          const bizomOrder = response.data.Data[0];
          return bizomOrder;
        } catch (error) {
          console.log("Error getting bizomOrders :", error);
          throw error;
        }
      })
      .catch(error => {
        console.error("Error during api call", error);
        throw error;
      });
  };

  const handleReturnAction = (returnId, action) => {
    const refundAmount = calculateReturnAmount(returnDetails, orderData, returnId)
    getBizomOrder().then(bizomOrder => {
        bizomOrder.refundAmount = refundAmount;
        const payload = {
            action: action,
            bizomOrder: bizomOrder,
            returnId: returnId,
            bizomReturns: serviceBizomMapping[returnId],
          };

      axios.post('orders/saleReturnActionForService', payload)
        .then((data) => {
          refreshOrder();
        })
        .catch((error) => console.log(error));
    }).catch(error => {
      console.error("Error finding bizom order", error);
    });
  };

  return (
    <TableContainer component={Paper} sx={{ marginTop: 2 }}>
      <Table aria-label="return details table">
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              variant="head"
              colSpan={6}
              sx={{
                fontWeight: "bold",
                fontSize: "medium",
                backgroundColor: 'lightgray'
              }}
            >
              {RETURN_DETAILS}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>{RETURN_ID}</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>{ITEM_ID}</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>{QUANTITY}</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>{REASON}</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>{IMAGE}</TableCell>
            <TableCell align="right" sx={{ fontWeight: "bold" }}>{ACTIONS}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {returnDetails.map((returnDetail) => (
            <React.Fragment key={returnDetail.returnId}>
              {returnDetail.items.map((item, index) => (
                <TableRow key={item.id}>
                  {index === 0 && (
                    <TableCell align="right" rowSpan={returnDetail.items.length}>
                      {returnDetail.returnId.slice(-4)}
                    </TableCell>
                  )}
                  <TableCell align="right">{item.id}</TableCell>
                  <TableCell align="right">{item.quantity}</TableCell>
                  <TableCell align="right">{item.reason}</TableCell>
                  <TableCell align="right">
                    <img src={item.image} alt="Item" style={{ width: '50px' }} />
                  </TableCell>
                  {index === 0 && (
                    <TableCell align="right" rowSpan={returnDetail.items.length}>
                      {returnDetail.state === 'return_request' ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <Button
                            variant="outlined"
                            color="success"
                            onClick={() => handleReturnAction(returnDetail.returnId, "ACCEPT")}
                            sx={{ marginBottom: 1 }}
                          >
                            Accept
                          </Button>
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleReturnAction(returnDetail.returnId, "REJECT")}
                          >
                            Reject
                          </Button>
                        </Box>
                      ) : (
                        <Typography variant="body2">
                          { returnDetail.state}
                        </Typography>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReturnDetailsCard;
